export default {
    isLoading: false
}
